module.exports = __webpack_public_path__ + "img/logo-idaho-nat-lab-bw.f09ddb15.png";